import React from "react";

const KetentuanLayananID: React.FC = () => (
  <>
    <p>
      Syarat dan Ketentuan ini (&quot;<strong>Syarat dan Ketentuan</strong>
      &quot;) menjabarkan perjanjian antara PT IQ Edukasi, suatu perseroan
      terbatas yang didirikan secara sah berdasarkan hukum negara Republik
      Indonesia yang berdomisili di Jakarta Selatan (&quot;<strong>kami</strong>
      &quot;, &quot;<strong>Colearn</strong>&quot;) dan pihak mana pun (orang
      perseorangan) yang mengakses dan/atau menggunakan (&quot;
      <strong>Pengguna</strong>&quot;, &quot;<strong>Anda</strong>&quot;)
      https://colearn.id or aplikasi seluler CoLearn® atau setiap aplikasi
      lainnya, website, fitur, teknologi, konten, dan produk digital (&quot;
      <strong>Platform</strong>&quot;) yang dimiliki oleh dan/atau dioperasikan
      oleh kami.
    </p>
    <p>
      Dengan mengakses atau menggunakan Platform kami, Anda dengan ini
      menyatakan dan menjamain kepada kami bahwa Anda memenuhi syarat
      berdasarkan hukum untuk menjadi Pengguna, yakni salah satu di antara hal
      berikut: (i) Anda tidak berusia dibawah 18 (delapan belas) tahun; (ii)
      Anda telah mendapatkan persetujuan dari orang tua atau wali yang sah
      (sebagaimana relevan) apabila Anda berusia di bawah 18 (delapan belas)
      tahun atau berada di bawah pengampuan dan penggunaan tersebut telah dibuat
      atau disetujui oleh orang tua atau wali Anda yang sah; atau (iii) Anda
      telah menikah. Anda mengakui bahwa kami tidak memiliki kewajiban untuk
      memastikan bahwa Anda memenuhi syarat tersebut di atas. Hal tersebut akan
      menjadi tanggung jawab Anda sepenuhnya untuk memastikan bahwa Anda
      memenuhi kualifikasi yang disyaratkan.
    </p>
    <p>
      Telah dijelaskan bahwa CoLearn tidak akan bertanggung jawab atas setiap
      konsekuensi yang mungkin mucul sebagai akibat dari penyalahgunaan Platform
      kami atau penggunaan jasa kami yang mungkin terjadi karena seseorang
      termasuk orang yang tidak memenuhi syarat yang disebutkan di atas yang
      mendaftar untuk menggunakan Platform atau jasa kami. Apabila Pengguna
      tidak memenuhi persyaratan tersebut, maka tindakan Pengguna untuk
      mendaftar,mengakses, menggunakan atau melakukan tindakan lain dalam
      Platform kami akan dianggap berada dalam pengawasan dan persetujuan sah
      dari orang tua atau wali Pengguna. Orang tua atau wali yang telah
      memberikan persetujuan atau dianggap telah memberikan persetujuan atau
      dianggap telah memberikan persetujuan (sebagaimana disebutkan sebelumnya)
      kepada Pengguna di bawah 18 (delapan belas) tahun atau di bawah pengampuan
      (sebagaimana relevan) akan sepenuhnya bertanggung jawab atas seuruh
      aktivitas dari Pengguna dalam menggunakan dan mengakses Platform atau jasa
      kami. Apabila Pengguna tidak memenuhi persyaratan tersebut maka yang
      bersangkutan tidak diizinkan sebagai Pengguna dan harus segera berhenti
      mengakses Platform atau informasi yang tersedia pada Platform.
    </p>
    <p>
      Anda menyatakan dan menjamin bahwa dengan mendaftar dan/atau menggunakan
      Platform kami, Pengguna dan/atau orang tua atau wali Pengguna (jika
      Pengguna berusia di bawah 18 tahun) dianggap telah membaca, memahami, dan
      menyetujui seluruh ketentuan dan konten dalam Syarat dan Ketentuan ini
      beserta perubahan/revisi oleh CoLearn dari waktu ke waktu.
    </p>
    <p>
      JIKA PENGGUNA TIDAK SETUJU DENGAN SYARAT DAN KETENTUAN INI, MAKA PENGGUNA
      TIDAK BOLEH MELANJUTKAN UNTUK MENGAKSES DAN MENGGUNAKAN
      PLATFORM/JASA/KONTEN CoLearn.
    </p>
    <ol type="A">
      <li>
        <strong>
          Mendaftarkan Akun
          <br />
        </strong>
        Sebelum menggunakan Platform, Pengguna menyetujui Syarat, dan Ketentuan
        ini serta Kebijakan Privasi (berikut dengan perubahannya yang akan
        dibuat dari waktu ke waktu) secara keseluruhan dan mendaftarkan dirinya
        dengan menyediakan informasi yang kami persyaratkan dan juga
        mengkonfirmasi bahwa Pengguna telah memenuhi syarat termasuk kesehatan
        mental Pengguna. Saat mendaftar, kami akan meminta Pengguna untuk
        memberikan nama lengkap, alamat email dan nomor telepon pribadi Pengguna
        (termasuk data- data dari orang tua atau wali yang sah, apabila Pengguna
        berusia di bawah 18 (delapan belas) tahun). Kami dapat mengawasi dan
        juga menghentikan akses anda terhadap Platform jika di masa mendatang
        data/informasi yang Pengguna berikan kepada kami terbukti tidak benar
        atau kami mencatat adanya pelanggaran terhadap ketentuan (termasuk
        undang- undang) yang berlaku untuk akses ke Platform, konten, dan
        informasi kami yang dapat diakses sebagai Pengguna.
        <p>
          Ketika seorang Pengguna telah terdaftar, kami akan memberikan kepada
          Pengguna sebuah kode akses yang dapat Pengguna gunakan untuk mengakses
          dan menggunakan Platform/layanan/konten CoLearn (&quot;
          <strong>Kode Akses</strong>&quot;). Pengguna tidak diperbolehkan untuk
          mengizinkan siapa pun untuk menggunakan akun Pengguna atau mengizinkan
          pihak ketiga untuk dengan cara apa pun mengakses atau menggunakan
          Platform (termasuk konten dan data di dalamnya atau yang bersumber
          dari Platform).
        </p>
        <p>
          Kecuali diizinkan secara khusus, jangan membagikan (atau memberikan
          akses atas) informasi Kode Akses atau data di dalam Platform kepada
          siapapun. Pengguna sepenuhnya bertanggung jawab untuk menjaga
          kerahasiaan dan keamanan Kode Akses, akses terhadap Platform dan atas
          semua aktivitas (termasuk informasi atau konten yang dapat diakses
          melalui atau berasal dari Platform) yang terjadi terhadap atau melalui
          Kode Akses, dan Pengguna setuju untuk segara memberitahukan kepada
          kami secara tertulis (email yang layak) atas setiap pelanggaran
          keamanan terhadap Kode Akses. Kami tidak bertanggung jawab atas
          kerugian yang timbul dari penyalahgunaan atau penggunaan yang tidak
          sah atas Kode Akses (termasuk informasi atau konten yang diakses dari
          atau dapat diakses melalui Platform).
        </p>
        <p>
          Kami akan menganggap setiap penggunaan atau perintah yang dilakukan
          melalui Akun Pengguna sebagai permintaan yang sah dari Pengguna. Harap
          segera memberitahukan kami jika Pengguna mengetahui atau mencurigai
          bahwa Akun Pengguna telah digunakan tanpa sepengetahuan dan
          persetujuan Pengguna. Kami akan mengambil tindakan yang kami anggap
          perlu dan dapat dilakukan terhadap penggunaan tanpa persetujuan
          tersebut.
        </p>
      </li>
      <li>
        <strong>
          Data Pribadi Pengguna
          <br />
        </strong>
        Pengumpulan, penyimpanan, pemrosesan, penggunaan dan pembagian data
        pribadi Pengguna, seperti nama, alamat email dan nomor telepon pribadi
        Pengguna yang diberikan saat Pengguna membuka Akun akan tunduk pada
        Kebijakan Privasi, yang merupakan bagian yang tidak terpisahkan dari
        Syarat dan Ketentuan ini.
        <p>
          Selanjutnya kami dapat juga membagikan beberapa Data Pribadi Pengguna
          kepada pihak ketiga tertentu, seperti email, alamat IP, atau informasi
          tentang browser, nomor identifikasi perangkat, atau sistem operasi
          yang Anda gunakan atau data analitis yang timbul darinya kepada pihak
          ketiga seperti pengiklan, biro iklan, dan/atau perantara periklanan,
          informasi relevan yang diperlukan untuk memilih dan menawarkan iklan
          yang sesuai kepada Anda dan pengguna lain yang dapat berupa iklan
          produk pihak ketiga sebagaimana adanya, termasuk informasi yang
          terkandung dalam cookie atau pengidentifikasi online lainnya (jika
          berisi Data Pribadi). Dalam hal iklan pihak ketiga, kami tidak
          menganjurkan penggunaan, menyetujui kualitas, atau merekomendasikan
          penggunaan produk atau layanan pihak ketiga yang diiklankan. Dengan
          demikian, terlepas dari persyaratan apa pun, tidak ada klaim yang
          harus dibuat terhadap CoLearn atau perwakilannya atas keputusan/
          tindakan Anda.
        </p>
        <br />
      </li>
      <li>
        <strong>
          Akses terhadap Platform
          <br />
        </strong>
        Kami tidak menjamin bahwa Platform kami, atau konten di dalamya, akan
        selalu tersedia atau tidak terganggu. Izin untuk mengakses Platform kami
        bersifat sementara. Kami dapat menangguhkan, menarik, menghentikan atau
        mengganti bagian mana pun dari Platform kami tanpa pembertahuan
        sebelumnya. Jika Anda atau dalam hal Anda berusia di bawah 18 (delapan
        belas) tahun, dan orang tua atau wali yang sah Anda tidak setuju dengan
        Syarat dan Ketentuan atau Kebijakan Privasi, mohon untuk tidak
        menggunakan Platform atau Situs CoLearn atau memanfaatkan Layanan atau
        produk. Setiap akses ke Layanan/Platform/konten kami dalam bentuk
        pendaftaran/langganan tidak dapat dialihkan dan hanya dapat digunakan
        oleh Pengguna. Kami tidak bertanggung jawab atas hal apapun yang
        menyebabkan Platform kami tidak dapat digunakan pada waktu atau period
        tertentu.
        <p>
          Anda juga setuju untuk mengambil segala tindakan yang wajar untuk
          menghentikan penggunaan yang tidak sah dan untuk bekerjsama dengan
          kami dalam setiap investigasi terhadap pengunaan yang tidak sah atau
          pelanggaran tersebut. Kami tidak akan dalam kondisi apapun dimintakan
          pertanggung jawaban atau bertanggung jawab atas klaim apapun
          sehubungan dengan penggunaan atau penyalahgunaan Akun Anda karena
          perbuatan pihak ketiga mana pun atau karena kesalahan Anda untuk
          menjaga kerahasiaan, control atau keamanan atas akses atau Akun Anda,
          produk atau sistem yang digunakan untuk memanfaatkan Layanan kami.
        </p>
        <p>
          Kualitas Siaran: Resolusi dan kualitas dari konten edukasi yang Anda
          terima akan bergantung pada berbagai faktor, termasuk jenis dari
          perangkat yang sesuai dimana Anda mengakses Platform/konten dan
          kemampuan internet Anda, dimana dapat meningkat atau menurusn selama
          Anda melihat atau menggunakan Platform kami. Ketika kami berusaha
          untuk menyediakan pengalaman menonton berkualitas tinggi kepada Anda,
          kami tidak menjamin resolusi atau kualitas konten dalam Platform kami
          yang akan anda terima ketika melakukan siaran atau terlihat pada
          perangkat Anda.
        </p>
      </li>
      <li>
        <strong>
          Langganan dan Tidak Adanya Pengembalian Dana
          <br />
        </strong>
        Jika Anda (dan jika Anda berusia di bawah 18 (delapan belas) tahun, maka
        orang tua atau wali Anda yang sah) tidak setuju atau dianggap setuju
        secara tidak dapat ditarik kembali dengan Syarat dan Ketentuan serta
        Kebijakan Privasi secara keseluruhan, mohon untuk tidak mendaftar atau
        menggunakan Platform atau Situs CoLearn atau memanfaatkan Layanan atau
        produk (sebagaimana berlaku). Anda setuju bahwa Layanan/Produk tertentu
        pada Platform kami tersedia dengan tunduk pada biaya langganan dengan
        pembayaran di muka (sesuai dengan ketentun yang berlaku atas produk dan
        biaya langganan yang berlaku sebagaimana dikomunikasikan melalui halaman
        produk kami) dan mungkin tidak tersedia untuk Anda kecuali jika Anda
        telah menyelesaikan proses berlangganan dan melakukan pembayaran Biaya
        Langganan kepada rekening bank yang kami tunjuk. Kecuali ditentukan lain
        pada Platform kami untuk Prduk/Layanan langganan tertentu, Biaya
        Langganan yang berlaku tidak dapat dinegosiasikan, bersifat final dan
        harus dibayar di muka.
        <p>
          <strong>TIDAK ADA PENGEMBALIAN DANA</strong>: Harap membaca syarat dan
          ketentuan berlangganan dengan saksama sebelum berlangganan paket
          berlangganan mana pun, karena ketika Pengguna telah berlangganan suatu
          paket dan melakukan pembayaran kepada kami, Pengguna memahami bahwa
          tidak akan terdapat pilihan untuk mengubah, menyesuaikan atau
          membatalkan paket berlangganan Anda dan tidak ada pengembalian dana
          atau kredit dalam bentuk apa pun yang diperkenankan, terlepas dari
          apakah layanan telah digunakan atau tidak. Dengan ketentuan bahwa,
          CoLearn atas kebijakan tunggalnya dapat memilih untuk menawarkan
          kemungkinan pengembalian dana dan/atau peningkatan paket berlangganan
          selama periode penawaran (sampai dengan dihentikan oleh CoLearn)
          tunduk pada ketentuan penawaran yang tersedia pada waktu berlangganan
          paket. Saat ini, CoLearn bermaksud untuk menawarkan kemungkinan
          pengembalian dana untuk paket live class CoLearn bagi Pengguna baru
          yang baru melanggan paket tersebut, tunduk pada kriteria sebagai
          berikut:
          <ol type="a">
            <li>
              Berlaku hanya untuk siswa baru yang mendaftar pada CoLearn untuk
              pertama kali;
            </li>
            <li>
              Apabila siswa menghadiri 80% live class pada bulan pertama sejak
              dimulainya berlangganan live class;
            </li>
            <li>
              Permintaan untuk pengembalian dana bagi Pengguna yang memenuhi
              syarat dapat dilakukan dalam waktu 14 hari segera setelah
              berakhirnya bulan pertama dari paket berlangganan baru oleh
              Pengguna baru/siswa baru, sebagaimana berlaku. Dengan ini
              dijelaskan bahwa seluruh permintaan pengembalian dana tersebut:
              <ol type="i">
                <li>
                  Wajib dimintakan melalui nomor WhatsApp yang terdaftar atas
                  nama CoLearn dengan mengirimkan pesan WhatsApp yang jelas
                  kepada nomor WhatsApp kami: +6281119103018 (hanya pesan teks);
                </li>
                <li>
                  Tunduk pada ketersediaan orang tua/wali dari Pengguna baru
                  tersebut untuk melakukan telepon verifikasi permintaan
                  pengembalian dana dan pemrosesan dokumen, segera CoLearn dalam
                  waktu 7 (tujuh) hari kerja setelahnya, memproses pengembalian
                  dana atas jumlah biaya berangganan yang dibayarkan oleh
                  Pengguna baru untuk paket berlangganan baru yang memenuhi
                  persyaratan untuk permintaan pengembalian dana sebagaimana
                  disebutkan sebelumnya.
                </li>
              </ol>
            </li>
          </ol>
        </p>
        <p>
          CoLearn menggunakan kecerdasan buatan/pemelajaran mesin untuk
          penyediaan layanan/produk yang lebih baik atau untuk meningkatkan
          layanan/produk, komunikasi yang lebih baik atau analisa CoLearn untuk
          meningkatkan Produk kami atau komunikasi penjualan/pemasaran yang
          lebih baik; dan hal tersebut dapat melibatkan penggunaan informasi
          tersebut pada peralatan yang disediakan kepad kami dan dimiiki oleh
          penyedia jasa pihak ketiga (termasuk kecerdasan buatan dari perangkat
          lunak sumber terbuka). Harap menjadi perhatian bahwa teknologi terus
          berkembang dan meskipun kami berusaha untuk meminimalisir kesalahan,
          kami mungkin tidak dapat memastikan hal tersebut bebas dari kesalahan
          dan tidak ada klaim yang akan muncul dari hal tersebut. Oleh
          karenanya, penggunaan layanan/produk kami tunduk pada penafian
          tersebut. Namun, karena kami terus berupaya untuk meningkatkan Layanan
          dan pengalaman Pengguna, kami mohon bantuan untuk memberitahukan kami
          masukan Anda melalui nomor WhatsApp kami: +6281119103018 (hanya pesan
          teks) / alamat surat elektronik{" "}
          <a href="mailto:info@colearn.id">info@colearn.id</a> dan kami akan
          mengambil langkah-langkah yang wajar.
        </p>
        <p>
          Lebih lanjut, telah disepakati bahwa Anda dapat memilih pihak ketiga
          yang memenuhi syarat/dapat diterima sebagai metode/perantara
          pembayaran atas kebijakan dan tanggung jawab Anda untuk berlangganan
          platform/produk/layanan kami. Telah dipastikan bahwa kami tidak akan
          bertanggung jawab terhadap atau dijadikan sebagai pihak dalam
          perselisihan antara Anda dan pihak ketiga tersebut dan Anda harus
          kapan pun membela/melindungi kami (termasuk perwakilan dan afiliasi
          kami) dari klaim, biaya atau pengeluaran yang timbul akibat
          perselisihan tersebut.
        </p>
        <p>
          Anda menyatakan dan menjamin bahwa seluruh informasi yang Anda berikan
          kepada kami adalah akurat, benar dan terkini. Setiap penyimpangan
          terhadap hal ini mengakibatkan pembatalan seketika atas layanan dan
          akses Pengguna ke Platform kami atas kebijakan kami tanpa
          pemberitahuan atau pengembalian dana/kredit dalam bentuk apa pun.
        </p>
      </li>
      <li>
        <strong>
          Penggunaan yang Dilarang
          <br />
        </strong>
        Platform kami hanya dapat digunakan oleh Pengguna untuk hal-hal yang
        dibenarkan menurut hukum dan dibenarkan berdasarkan Syarat dan Ketentuan
        ini. Tidak terbatas pada hal-hal berikut, penggunaan secara langsung
        maupun tidak langsung pada Platform kami (termasuk konten/data yang
        diakses pada Platform) oleh Pengguna untuk hal-hal sebagai berikut
        adalah tidak dibenarkan:
        <br />
        <ol type="a">
          <li>
            Dengan cara-cara yang melanggar hukum dan peraturan lokal, nasional,
            maupun internasional yang berlaku;
          </li>
          <li>
            Dengan cara-cara yang melanggar hukum atau menipu, atau memiliki
            tujuan atau dampak yang melanggar hukum atau menipu;
          </li>
          <li>
            Untuk tujuan membahayakan atau mencoba mencelakakan anak di bawah
            umur (termasuk namun tidak terbatas pada setiap tutor, siswa dan
            perwakilan yang terkait dalam kapasitas apapun dengan CoLearn)
            dengan cara apa pun;
          </li>
          <li>
            Mengirim, menerima, mengunggah, menyalin, menjiplak, mengunduh
            (termasuk tangkapan layar atau rekaman/berbagi layar), mengubah,
            menunjukkan penggunaan, atau menggunakan kembali materi yang tidak
            sesuai dengan standar konten kami, Syarat dan Ketentuan dan/atau
            peraturan yang berlaku;
          </li>
          <li>
            Menyebarkan, membagikan, menampilkan atau mengirimkan materi iklan
            atau promosi yang tidak diinginkan atau tidak sah dan bentuk
            permintaan serupa lainnya (seperti spam).
          </li>
          <li>
            Meneruskan data, mengirim atau mengunggah materi yang mengandung
            <em>
              virus, trojan, worm, logic bomb, keystroke loggers, spyware,
              adware
            </em>
            maupun program berbahaya lainnya atau kode komputer sejenis yang
            dirancang untuk memberikan efek merugikan terhadap pengoperasian
            perangkat lunak atau perangkat keras atau Platform dalam bentuk apa
            pun.
            <br />
            <p>Pengguna dengan ini setuju untuk:</p>
            <div>
              <ol type="a">
                <li>
                  Tidak, baik secara langusng maupun tidak langsung, membuat
                  kembali, menggandakan, menyalin, mengubah, mengimitasi,
                  menampilkan, membagikan, atau menjual kembali bagian mana pun
                  dari Platform kami (termasuk setiap konten/setiap yang
                  terkandung/setiap yang diakses pada Platform) yang
                  bertentangan dengan ketentuan dalam Syarat dan Ketentuan
                  Platform kami.
                </li>
                <li>
                  Untuk tidak mengakses tanpa izin, mengganggu, merusak, atau
                  mengacak-acak:
                  <br />
                  <ol type="i">
                    <li>bagian mana pun dari Platform kami;</li>
                    <li>
                      peralatan atau jaringan di mana Platform kami tersimpan;
                    </li>
                    <li>
                      perangkat lunak apa pun yang digunakan dalam penyediaan
                      Platform kami; atau
                    </li>
                    <li>
                      peralatan atau jaringan atau perangkat lunak yang dimiliki
                      oleh pihak ketiga mana pun.
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
            <p>
              <strong>Pengunduhan dalam Aplikasi</strong>: Anda hanya diberikan
              lisensi terbatas untuk melakukan pengunduhan dalam aplikasi atas
              konten edukasi dalam aplikasi seluler atau pada perangkat yang
              sesuai sebagaimana diizinkan. Penampilan atas layar atau
              pengunduhan pada perangkat lainnya atau dengan cara apapun yang
              tidak dibenarkan berdasarkan Syarat dan Ketentuan ini, akan, tanpa
              batasan pada jumlah ganti rugi lainnya, berakibat pada pengakhiran
              segera langganan bersamaan dengan pengakhiran akses kepada seluruh
              konten edukasi yang telah diunduh sekalipun dengan hak untuk
              melakukan tindakan hukum yang sesuai, atas kebijakan tunggal kami.
            </p>
          </li>
        </ol>
      </li>
      <li>
        <strong>
          Kebijakan Keselamatan Anak
          <br />
        </strong>
        Kebijakan ini berlaku untuk setiap orang, organisasi yang terkait dengan
        kami, termasuk:
        <br />
        <ol type="a">
          <li>
            Karyawan CoLearn, baik yang merupakan karyawan paruh waktu atau
            penuh waktu, karyawan tetap atau kontrak;
          </li>
          <li>
            Organisasi atau orang dalam organisasi tersebut, yang mungkin
            bermitra dan/atau bekerja dengan CoLearn dalam kapasitas apapun,
            termasuk untuk periode atau pekerjaan yang terbatas;
          </li>
          <li>
            Relawan yang mungkin bekerja dengan CoLearn, dalam kapasitas apapun,
            termasuk untuk periode yang terbatas;
          </li>
          <li>
            Anak-anak yang terdaftar sebagai siswa CoLearn dan orangtua atau
            wali mereka yang terkait dengan anak-anak di dalam catatan resmi
            CoLearn;
          </li>
          <li>
            Anak-anak yang mungkin tidak terdaftar tetapi terjangkau melalui
            kegiatan pemasaran atau penjualan produk dan orangtua atau wali
            mereka yang terkait dengan anak tersebut; dan
          </li>
          <li>
            Setiap orang atau organisasi yang mungkin secara resmi terkait
            dengan CoLearn dan lingkup pekerjaan dan aktivitas CoLearn.
          </li>
        </ol>
        <p>
          Dalam kasus dan keadaan dimana CoLearn mungkin tidak mensyaratkan
          kontrol atas pihak yang dikhawatirkan berdasarkan kebijakan ini,
          termasuk dalam hal kekerasan terhadap anak, CoLearn akan berusaha
          untuk menyediakan kerja sama, bantuan dan dukungan yang wajar dan
          diperlukan kepada orang tua atau wali dari anak yang terdampak, dalam
          rangka melakukan pendekatan hukum eksternal apapun termasuk dengan
          pihak kepolisian atau pengadilan, meskipun CoLearn tidak secara
          pribadi bertanggung jawab atau wajib bertanggung jawab dalam kondisi
          tersebut.
        </p>
      </li>
      <li>
        <strong>
          Hak Kekayaan Intelektual
          <br />
        </strong>
        <br />
        <p>
          Pengguna mengakui dan menyetujui tanpa syarat bahwa Platform kami,
          termasuk namun tidak terbatas pada konten mana pun yang terdapat pada
          Platform, nama, logo, kode program, desain, merek dagang, teknologi,
          basis data, konten dan proses dan model bisnis, merupakan kepemilikan
          CoLearn secara terus menerus dan secara global dan dilindungi secara
          kontraktual pada Syrat dan ketentuan ini dan oleh undang-undang yang
          sehubungan dengan hak kepemilikan, hak cipta, merek, paten, hak moral
          dan hak kekayaan intelektual lainnya yang secara terus menerus dan
          secara global dimiliki oleh kami atau afiliasi kami. Penggunaan isi
          dan konten Platform tunduk dan mengacu kepada Syarat dan Ketentuan
          ini. Konten, gambar, suara, publikasi, dan video pada Platform atau
          dengan cara apa pun oleh kami hanya dapat digunakan secara utuh apa
          adanya tanpa ada perubahan, untuk kebutuhan penggunaan pribadi dan
          non-komersial. Pengunduhan dan penggunaan lainnya yang melanggar
          Syarat dan Ketentuan ini dan peraturan perundang-undangan yang berlaku
          adalah perbuatan yang dilarang.
        </p>
        <p>
          Kecuali sepanjang telah diizinkan oleh CoLearn secara khusus dan
          tertulis, Pengguna tidak diperkenankan untuk mengganti/mengubah
          salinan dalam bentuk kertas maupun digital dari materi apa pun yang
          telah Pengguna cetak atau unduh dengan cara apa pun, selain dari pada
          cara yang telah diizinkan secara khusus dalam Platform dan Pengguna
          tidak boleh menggunakan ilustrasi, foto-foto, potongan video atau
          audio, maupun grafis lain secara terpisah dari teks pendampingnya.
        </p>
        <p>Pengguna dilarang untuk:</p>
        <ol type="a">
          <li>
            menyalin, mengubah, mencetak, mengadaptasi, menerjemahkan,
            menciptakan karya tiruan dari, mendistribusikan (selain dari cara
            berbagi yang dapat difasilitasi melalui platform CoLearn itu
            sendiri),memberi lisensi, menjual, memindahkan, menampilkan secara
            publik, menggandakan, mengirimkan, menyiarkan lewat media daring
            maupun luring, memanfaatkan untuk pengembangan kecerdasan buatan
            (termasuk tuning/embedding, dan lain-lain), machine learning,
            memotong, membongkar, atau sebaliknya mengeksploitasi bagian mana
            pun dari Platform kami, termasuk namun tidak terbatas pada
            konten-konten dan materi-materi berbayar/gratis pada Platform atau
            dengan cara lainnya, baik secara fisik maupun digital, yang secara
            terus- menerus dan dimanapun secara global selama masa berlangganan
            maupun setelah selesainya berlangganan Platform;
          </li>
          <li>
            memberi lisensi, memberi lisensi turunan, menjual, menjual ulang,
            mengirimkan, mengalihkan, mendistribusikan, atau sebaliknya
            mengeksploitasi atau membagikan secara komersial atau cara apapun
            konten, Platform, dan/atau perangkat lunak lain yang terasosiasi
            dengan Platform kami (termasuk konten atau data kami) dengan cara
            apa pun;
          </li>
          <li>
            menciptakan tautan internet menuju Platform kami, atau
            mengimitasi/menyadur (frame), atau mengkomputasi (mirror) perangkat
            lunak mana pun pada server atau perangkat nirkabel, IP, atau
            perangkat yang terhubung ke internet lainnya;
          </li>
          <li>
            merekayasa balik atau mengakses Platform kami untuk (i) membangun
            produk atau jasa yang kompetitif; (ii) membangun produk berdasarkan
            ide, fitur, fungsi, maupun grafis yang serupa dengan Platform kami;
            atau (iii) menyalin ide, fitur, fungsi, atau grafis pada Platform
            kami;
          </li>
          <li>
            menjalankan program atau skrip otomatis termasuk, namun tidak
            terbatas pada, web spiders, web crawlers, web robots, web ants, web
            indexing, bots, viruses, worms, atau program apa pun yang dapat
            meningkatkan permintaan server per detik, atau membuat beban terlalu
            berat yang mengganggu operasi dan/atau kinerja Platform kami;
          </li>
          <li>
            menggunakan robots, spiders, aplikasi pencarian atau pengambilan
            situs, maupun perlengkapan dan proses manual atau otomatis lain
            untuk mengambil, membuat indeks, menambang data, mengembangkan
            kecerdasan buatan (termasuk tuning/embedding, dan lain-lain),
            machine learning, atau dengan cara apa pun menggandakan, menggunakan
            tanpa izin, atau menghindari struktur navigasi atau tampilan
            Platform kami maupun kontennya;
          </li>
          <li>
            menempatkan, mendistribusikan, mempublikasikan/menggunakan tanpa
            izin atau menggandakan dengan cara apa pun materi yang
            dipublikasikan oleh CoLearn atau perwakilan kami, konten/materi
            dengan hak cipta, merek dagang, atau informasi kepemilikan lain
            tanpa sebelumnya memperoleh persetujuan dari pemilik hak kepemilikan
            dalam hal ini adalah CoLearn; dan
          </li>
          <li>
            mengubah atau menghapus hak cipta, merek dagang, atau tanda hak
            kepemilikan lainnya yang terkandung dalam Platform kami. Tidak ada
            lisensi atau hak yang diberikan kepada Pengguna secara implisit atau
            sebaliknya berdasarkan hak kekayaan intelektual yang dimiliki atau
            dikendalikan oleh kami dan pemberi lisensi kami, kecuali lisensi
            terbatas dan hak yang secara tersurat diberikan dalam Syarat dan
            Ketentuan ini untuk penggunaan yang hanya diizinkan bagi Pengguna
            terdaftar. Pengguna tidak boleh menggunakan bagian mana pun dari
            konten pada Platform kami untuk tujuan komersial tanpa sebelumnya
            memperoleh izin untuk melakukannya dari kami atau pemberi lisensi
            kami melalui kami.
          </li>
        </ol>

        <p>
          Status kami (dan status kontributor lain yang telah kami identifikasi)
          sebagai pembuat dan/atau pemilik ekslusif dari konten pada Platform
          (termasuk yang dapat diakses melalui Platform) dan Platform itu
          sendiri harus selalu diakui dan dihormati. Telah dipastikan pula bahwa
          konten CoLearn (tidak dihasilkan dari kecerdasan buatan) dapat diakses
          melalui Platform kami atau dengan cara lainnya dikembangkan (termasuk
          diawasi) oleh karyawan ahli atau konsultan kami semata-mata untuk
          CoLearn dan secara eksklusif dimiliki oleh CoLearn secara
          terus-menerus dan di seluruh dunia. Selanjutnya, kami berhak atas
          semua aset kepemilikan kami baik berwujud maupun tidak berwujud.
        </p>
        <p>
          Jika Pengguna mencetak, menyalin, atau mengunduh bagian mana pun dari
          Platfrom kami (termasuk konten kami), yang melanggar Syarat dan
          Ketentuan ini, maka tanpa membatasi hak dan upaya hukum CoLearn
          lainnya yang mungkin kami miliki berdasarkan ketentuan-ketentuan ini,
          hukum, dan keadilan, hak Pengguna untuk menggunakan Platform kami akan
          segera dihentikan berdasarkan kebijakan kami dan Pengguna wajib,
          berdasarkan keputusan kami, mengembalikan atau memusnahkan salinan
          dari materi yang telah Pengguna buat atau kuasai.
        </p>
        <p>
          Kami mereservasi hak kami untuk melakukan investigasi maupun menuntut
          bentuk pelanggaran apa pun terhadap Syarat dan Ketentuan ini sesuai
          dengan ketentuan hukum yang berlaku. Kami dapat melibatkan dan bekerja
          sama dengan pihak yang berwenang dalam menuntut pengguna yang
          melanggar Syarat dan Ketentuan ini. Pengguna mengakui bahwa kami tidak
          diwajibkan untuk mengawasi akses Pengguna terhadap Platform kami, tapi
          kami berhak untuk melakukannya dengan tujuan mengoperasikan Platform
          kami, memastikan kepatuhan Pengguna dengan Syarat dan Ketentuan ini,
          atau untuk menaati hukum yang berlaku atau putusan pengadilan, lembaga
          administratif, maupun badan pemerintahan lainnya.
        </p>
      </li>
      <li>
        <strong>
          <strong>
            Pengunggahan Konten pada Platform Kami
            <br />
          </strong>
        </strong>
        <br />
        <ol type="A">
          <li>
            Pengguna dapat menggunakan fitur yang memungkinkan Pengguna
            mengunggah konten maupun materi ke Platform kami, atau untuk
            berhubungan dengan pengguna Platform kami lainnya melalui layanan
            interaktif (&quot;<strong>Konten</strong>&quot;). Dengan ketentuan
            bahwa Konten tidak dibenarkan terkait dengan hal-hal berikut.
          </li>
        </ol>
        <div>
          <ol type="a">
            <li>Mengandung materi yang mencemarkan nama baik seseorang;</li>
            <li>
              Mengandung materi yang tidak senonoh, menyinggung, bersifat
              kebencian, atau menghasut;
            </li>
            <li>
              Menunjukkan konten yang berkaitan dengan perjudian, undian,
              dan/atau taruhan;
            </li>
            <li>
              Menunjukkan materi yang eksplisit secara seksual atau tidak
              bermoral;
            </li>
            <li>Menunjukkan kekerasan;</li>
            <li>
              Menunjukkan diskriminasi berdasarkan ras, jenis kelamin, agama,
              kebangsaan, kecacatan, orientasi seksual, atau usia;
            </li>
            <li>Menunjukkan jasa peretasan dan/atau pembobolan;</li>
            <li>
              Menunjukkan akses terhadap produk penipuan, pencucian uang, skema
              pemasaran berjenjang (<em>multi-level marketing</em>), serta
              produk bajakan;
            </li>
            <li>
              Menunjukkan akses terhadap perdagangan manusia dan organ tubuh
              manusia;
            </li>
            <li>Menunjukkan akses terhadap zat-zat terlarang dan narkotika;</li>
            <li>
              Menunjukkan akses terhadap rokok dan berbahan dasar tembakau;
            </li>
            <li>
              Mempromosikan penjualan tidak sah terhadap produk-produk yang
              membutuhkan izin (misalnya obat-obatan, bahan peledak, senjata
              api, dan lain-lain);
            </li>
            <li>
              Melanggar hak kekayaan intelektual termasuk hak cipta, hak
              pangkalan data (<em>database right</em>), atau pun merek dagang
              pihak lain;
            </li>
            <li>
              Dibuat dengan melanggar kewajiban hukum apa pun kepada pihak
              ketiga, seperti kewajiban kontrak atau kewajiban menjaga
              kerahasiaan;
            </li>
            <li>Menunjukkan aktivitas pelanggaran hukum apa pun;</li>
            <li>
              Mengancam, menyalahgunakan, atau menyerang privasi orang lain,
              atau menyebabkan gangguan, ketidaknyamanan, maupun kecemasan yang
              tidak perlu;
            </li>
            <li>
              Dapat melecehkan, menyinggung, mempermalukan, membuat khawatir,
              atau mengganggu siapa pun;
            </li>
            <li>
              Digunakan untuk menyamar sebagai orang lain, atau untuk memalsukan
              identitas atau afiliasi Anda dengan orang lain;
            </li>
            <li>
              Memberi kesan bahwa Konten tersebut berasal dari kami, ketika
              tidak benar demikian; dan
            </li>
            <li>
              Mengadvokasi, mempromosikan, atau membantu tindakan yang melanggar
              hukum seperti (hanya sebagai contoh) pelanggaran hak cipta atau
              penyalahgunaan komputer.
            </li>
          </ol>
        </div>
        <p style={{ paddingLeft: "40px" }}>
          Pengguna menjamin bahwa Konten tersebut telah mematuhi standar yang
          telah disebutkan, dan bahwa Pengguna akan bertanggung jawab secara
          penuh kepada kami dan mengganti kerugian kami atas pelanggaran
          terhadap jaminan tersebut. Dengan demikian, Pengguna akan bertanggung
          jawab untuk segala kerugian atau kerusakan yang kami derita akibat
          pelanggaran jaminan dari Pengguna.
        </p>
        <p>
          Seluruh Konten yang Pengguna unggah ke Platform kami akan dianggap
          bersifat tidak rahasia, tidak ada yang memiliki dan tidak melanggar
          hak kekayaan intelektual dari pihak manapun, kecuali Pengguna
          menyatakan sebaliknya kepada kami. Pengguna tetap memiliki semua hak
          kepemilikan terhadap Konten Pengguna, namun Pengguna diharuskan untuk
          memberi kami lisensi terbatas untuk menggunakan, menyimpan, dan
          menyalin Konten tersebut, serta untuk mendistribusikan dan membuatnya
          tersedia bagi pihak ketiga.
        </p>
        <p>
          Kami juga berhak mengungkapkan identitas Pengguna kepada pihak ketiga
          mana pun yang mengklaim bahwa Konten yang Pengguna tempatkan atau
          unggah merupakan pelanggaran terhadap hak kekayaan intelektual mereka,
          atau hak privasi mereka.
        </p>
        <p>
          Kami berhak menghapus setiap Konten yang Pengguna unggah pada Platform
          kami jika, menurut pendapat kami, Konten Pengguna tidak sesuai dengan
          standar konten yang ditetapkan dalam Syarat dan Ketentuan ini.
        </p>
        <p>
          Kami tidak bertanggung jawab atau dikenakan kewajiban oleh pihak
          ketiga mana pun, untuk Konten atau akurasi dari Konten mana pun yang
          Pengguna unggah ke dalam Platform kami.
        </p>
      </li>
      <li>
        <strong>
          Tindakan yang Kami Anggap Perlu
          <br />
        </strong>
        Apabila kami mengetahui atau mempunyai alasan yang cukup untuk menduga
        bahwa Pengguna telah melakukan tindakan tidak bermoral, pelanggaran,
        kejahatan atau tindakan lain yang bertentangan dengan Syarat dan
        Ketentuan ini dan/atau peraturan perundang-undangan yang berlaku, baik
        yang dirujuk dalam Syarat dan Ketentuan ini atau tidak, maka kami berhak
        untuk dan dapat memblokir Akun, baik sementara atau permanen, atau
        menghentikan akses Anda terhadap Platform, melakukan pemeriksaan,
        menuntut ganti kerugian, melaporkan kepada pihak berwenang dan/atau
        mengambil tindakan lain yang kami anggap perlu, termasuk tindakan hukum
        pidana maupun perdata.
        <p>
          Kami akan menindaklanjuti dengan melakukan investigasi dan/atau
          memfasilitasi pihak yang bersangkutan untuk melaporkan kepada pihak
          yang berwajib apabila kami menerima laporan adanya pelanggaran yang
          Pengguna lakukan atas Syarat dan Ketentuan ini ataupun pelanggaran
          terhadap peraturan perundang-undangan yang berlaku, sehubungan dengan
          pelecehan atau kekerasan verbal, termasuk namun tidak terbatas pada,
          terhadap fisik, jenis kelamin, suku, agama dan ras.
        </p>
      </li>
      <li>
        <strong>
          Membuat Tautan ke Platform Kami
          <br />
        </strong>
        Pengguna dapat membuat tautan ke Platform kami, dengan ketentuan bahwa
        Pengguna melakukannya dengan cara yang benar dan sah serta tidak merusak
        reputasi kami atau mengambil keuntungan darinya.
        <p>
          Pengguna tidak diperbolehkan membuat tautan sedemikian rupa sehingga
          memberikan kesan adanya suatu asosiasi, persetujuan, ataupun dukungan
          dari kami ketika hal tersebut tidak benar.
        </p>
        <p>
          Pengguna tidak diperbolehkan membuat tautan ke Platform kami pada
          situs web mana pun yang tidak dimiliki oleh Pengguna. Kami berhak
          mencabut izin pembuatan tautan tanpa pemberitahuan.
        </p>
      </li>
      <li>
        <strong>
          Tautan Pihak Ketiga pada Platform Kami
          <br />
        </strong>
        Dalam hal Platform kami mengandung tautan dan akses ke situs web dan
        konten lain yang disediakan oleh pihak ketiga, kami tidak memiliki
        kontrol atas konten situs web atau sumber tersebut. Kami tidak
        bertanggung jawab atas bagian apapun dari konten yang disediakan oleh
        pihak ketiga. Akses atau penggunaan Pengguna terhadap konten pihak
        ketiga tersebut merupakan bentuk persetujuan Pengguna untuk tunduk pada
        Syarat dan Ketentuan dan kebijakan privasi yang ditetapkan oleh pihak
        ketiga tersebut.
      </li>
      <li>
        <strong>Tanggung Jawab Pengguna</strong>
        <br />
        Pengguna bertanggung jawab secara penuh atas setiap kerugian dan/atau
        klaim yang timbul dari penggunaan Platform melalui akun Pengguna, baik
        oleh Pengguna atau pihak lain yang menggunakan akun Pengguna, dengan
        cara yang bertentangan dengan Syarat dan Ketentuan ini, peraturan
        perundang-undangan yang berlaku, pelanggaran hak kekayaan intelektual
        dan/atau aktivitas lain yang merugikan publik dan/atau pihak lain
        manapun atau yang dapat atau dianggap dapat merusak reputasi kami. Kami
        tidak menjamin bahwa Platform akan aman atau terbebas dari&nbsp;
        <em>bug</em>&nbsp;atau&nbsp;<em>virus</em>. Pengguna bertanggung jawab
        untuk mengelola keberlangsungan, keselamatan, keamanan teknologi
        informasi, Kode Akses, program komputer, serta platform yang Anda
        gunakan untuk mengakses Platform/jasa/konten kami (termasuk kewajiban
        Anda sendiri untuk memastikan kerahasiaan dan izin akses atau penggunaan
        Platform dan konten kami. Pengguna harus menggunakan perangkat lunak,
        perangkat yang sesuai dan anti-virus Pengguna sendiri.
        <p>
          Anda setuju untuk mengganti rugi, membela dan membebaskan CoLearn,
          para petugas, direktur, karyawan, konsultan dan agen CoLearn, dari
          setiap dan seluruh tuntutan termasuk tuntutan pihak ketiga, kewajiban,
          kerugian dan/atau biaya (termasuk namun tidak terbatas pada biaya
          konsultan atau biaya hukum) yang timbul dari penggunaan Anda terhadap
          Platform atau jasa, atau setiap pembajakan atau pelanggaran oleh Anda
          atau setiap pengguna lain dari Akun Anda, atas setiap Syarat dan
          Ketentuan termasuk kekayaan intelektual atau hak lain dari sesesorang
          atau entitas, atau peraturan perundang-undangan dan kebijakan yang
          berlaku berikut dengan perubahannya dari waktu ke waktu.
        </p>
      </li>
      <li>
        <strong>
          Penafian dan Batasan Tanggung Jawab
          <br />
        </strong>
        Pengguna memahami dan menyetujui bahwa layanan dalam Platform kami
        disediakan dengan &quot;apa adanya&quot; dan &quot;sebagaimana
        tersedia&quot;. Sejauh dimungkinkan oleh peraturan perundang-undangan
        yang berlaku, kami tidak, baik secara tegas maupun tersirat, membuat
        suatu jaminan, mendukung atau memberikan pernyataan dalam bentuk apa pun
        sehubungan dengan pemberian layanan dalam Platform kami, hal ini
        termasuk namun tidak terbatas pada: &nbsp;tidak adanya jaminan
        sehubungan dengan penjualan dan kesesuaian untuk tujuan tertentu dan
        tidak adanya pembajakan; dan tidak ada jaminan bahwa akses terhadap atau
        penggunaan Platform tidak akan terganggu atau menjadi kacau atau tidak
        ada kesalahan (<em>error</em>) atau cacat pada Platform akan diperbaiki.
        <p>
          Sepanjang diperbolehkan oleh peraturan perundang-undangan yang
          berlaku, dalam hal apapun CoLearn, para petugas, direktur, karyawan
          atau agen CoLearn, tidak akan bertanggung jawab kepada Anda atas
          segala bentuk kerugian atau kerusakan, baik yang terjadi secara
          langsung, tidak langsung, merupakan kebetulan, khusus, atau sanksi,
          atau hilangnya data, penggunaan,&nbsp;muhibah, atau kerugian tidak
          berwujud lainnya, yang diakibatkan karena (i) akses Pengguna untuk
          menggunakan, atau penggunaan atas, atau ketidakmampuan untuk
          mengakses, atau menggunakan Platform; (ii) setiap tindakan atau konten
          yang disediakan oleh pihak ketiga yang berkaitan dengan Platform;
          (iii) akses, penggunaan atau perubahan yang tidak sah atas konten
          apapun pada Platform; atau (iv) permasalahan-permasalahan lainnya yang
          muncul bukan disebabkan oleh pelanggaran oleh kami terhadap Syarat dan
          Ketentuan ini. Sepanjang diperbolehkan oleh peraturan
          perundang-undangan yang berlaku, total tanggung jawab/kewajiban kami
          atas segala klaim yang timbul dari pelanggaran terhadap Syarat dan
          Ketentuan ini, hanya terbatas pada jumlah yang Pengguna bayarkan
          kepada kami untuk menggunakan layanan pada Platform kami pada saat
          terjadinya klaim.
        </p>
        <p>
          Dengan menggunakan dan mengakses Platform kami, Pengguna setuju untuk
          secara mandiri memverifikasi secara mandiri keaslian dan kebenaran
          jawaban, informasi, materi dan konten yang dipublikasikan dalam
          Platform atau situs. Lebih lanjut, CoLearn tidak memberikan jaminan
          atau pernyataan sehubungan dengan hasil yang mungkin didapat dari
          penggunaan jasa dalam Platform, sehubungan dengan ketepatan atau
          keandalan atas setiap informasi (termasuk namun tidak terbatas pada
          konten, video dan data, dan lain sebagainya) yang didapat melalui jasa
          pada Platform atau yang Platform/jasa akan sesuaikan dengan permintaan
          Pengguna, atau tidak terganggu, tepat waktu, aman atau bebas dari
          kesalahan. Penggunaan setiap materi dan/atau data yang diunduh,
          dilihat atau dengan cara lain didapatkan atau diakses melalui
          penggunaan Platform/jasa adalah merupakan kebijakan dan risiko tunggal
          dari Pengguna. Seluruh risiko yang muncul dari penggunaan atau
          pelaksanaan jasa adalah milik Anda. CoLearn tidak memiliki kewajiban
          apapun untuk menyimpan informasi apapun dari Pengguna atau komunikasi
          dengan atau antara Pengguna. Penggunaan Platform dan setiap tindakan
          yang Pengguna lakukan atas dasar informasi yang terdapat di Platform
          adalah tanggung jawab dan risiko Pengguna sendiri dan kami tidak
          bertanggung jawab atas konsekuensi tindakan yang Pengguna lakukan.
        </p>
      </li>
      <li>
        <strong>Keadaan Kahar</strong>
        <br />
        Platform kami dan ketersediaan jasa kami (seluruh atau sebagian) dapat
        terganggu oleh kejadian di luar kewenangan atau kontrol kami (&quot;
        <strong>Keadaan Kahar</strong>&quot;), termasuk namun tidak terbatas
        pada bencana alam, epidemi, kerusuhan, karantina wilayah, gangguan
        listrik, gangguan telekomunikasi, perubahan peraturan perundang-undangan
        yang berlaku dan kebijakan pemerintah, dan lain-lain. Pengguna setuju
        untuk membebaskan kami dan afiliasi kami dari setiap tuntutan dan
        (termasuk tuntutan pengembalian dana) dan tanggung jawab, jika kami
        tidak dapat memfasilitasi layanan (sebagian atau seluruhnya), termasuk
        memenuhi instruksi yang Pengguna berikan melalui Platform, baik sebagian
        maupun seluruhnya, karena suatu Keadaan Kahar.
      </li>
      <li>
        <strong>Hukum yang Berlaku</strong>
        <br />
        Syarat dan Ketentuan ini diatur berdasarkan hukum Republik Indonesia.
        Setiap dan seluruh perselisihan yang timbul dari penggunaan Platform dan
        Syarat dan Ketentuan ini tunduk pada yurisdiksi eksklusif pada
        Pengadilan Negeri Jakarta Selatan.
      </li>
      <li>
        <strong>
          Bahasa
          <br />
        </strong>
        Syarat dan Ketentuan ini dibuat dalam Bahasa Indonesia dan bahasa
        Inggris. Dalam hal terdapat ketidaksesuaian atau perbedaan penafsiran
        antara versi Bahasa Indonesia dan versi bahasa Inggris, Pengguna setuju
        bahwa versi Bahasa Indonesia yang akan berlaku atas ketidaksesuaian atau
        pertentangan tersebut (sebagaimana disyaratkan oleh peraturan
        perundang-undangan yang berlaku), dan versi bahasa Inggris yang terkait
        akan dianggap secara otomatis diubah agar konsisten dengan bagian
        terkait dari versi Bahasa Indonesia.
      </li>
      <li>
        <strong>Komunikasi</strong>
        <br />
        Kami mungkin menghubungi/mengirimkan kepada Anda promosi, informasi
        jasa/produk kami, umpan balik/ulasan dari jasa/produk kami atau bentuk
        komunikasi lainnya dengan anda secara elektronik, dimana dapat termasuk
        surat elektronik, push notification (melalui aplikasi atau pesan
        termasuk melalui WhatsApp kepada nomor telepon Anda, dan lain
        sebagainya) dan Anda dengan ini setuju untuk menerima komunikasi
        tersebut. Komunikasi ini akan sesuai dengan Kebijakan Privasi kami.
      </li>
      <li>
        <strong>Ketentuan Lainnya</strong>
        <br />
        <ol type="i">
          <li>
            Pengguna mengerti dan setuju bahwa Syarat dan Ketentuan ini
            merupakan persetujuan dalam bentuk elektronik dengan mengakses
            Platform kami dan konfirmasi lebih lanjut dengan dan tindakan
            Pengguna menekan tombol ‘daftar’ saat pembukaan Akun atau tombol
            ‘masuk’ saat akan mengakses Akun Pengguna merupakan persetujuan
            aktif Pengguna untuk mengikatkan diri dalam perjanjian dengan kami
            sehingga keberlakuan Syarat dan Ketentuan ini dan Kebijakan Privasi
            adalah sah dan mengikat secara hukum dan terus berlaku sepanjang
            penggunaan Platform, layanan dan data CoLearn dan sepanjang CoLearn
            masih tersedia.
          </li>
          <li>
            Modifikasi/Perubahan: CoLearn mereservasi hak untuk mengubah,
            memblokir atau mengakhiri paket atau jasa berlangganan, atau bagian
            manapun dari paket atau jasa berlangganan, kapanpun dan tanpa
            pemberitahuan (kecuali sebagaimana diwajibkan oleh peraturan
            perundang-udangan yang berlaku, dengan menampilkan
            ketentuan-ketentuan yang telah diubah sehubungan dengan layanan.
            Sepanjang diperbolehkan oleh hukum, keberlanjutan penggunaan oleh
            Anda atas layanan setelah setiap perubahannya merupakan bentuk
            penerimaan atas perubahan tersebut. Kami tidak akan bertanggung
            jawab kepada Anda apabila CoLearn melakukan hak perubahan tersebut,
            meskipun kemampuan Anda untuk menggunakan jasa atau mengakses
            Colearn terdampak atas perubahan tersebut.
          </li>
          <li>
            Kami dapat mengubah Syarat dan Ketentuan ini kapan pun dengan
            mengubah halaman ini. Mohon kunjungi kembali halaman ini dari waktu
            ke waktu guna memperhatikan ada tidaknya perubahan yang kami buat,
            karena perubahan tersebut akan mengikat Pengguna dari waktu ke
            waktu.
          </li>
          <li>
            Kami dapat memperbarui Platform dari waktu ke waktu serta mengubah
            kontennya kapan pun. Meskipun demikian, perlu diketahui bahwa
            Platform kami dapat memiliki konten yang tidak diperbarui pada waktu
            tertentu, dan kami tidak bertanggung jawab untuk memperbaruinya.
            Kami tidak menjamin bahwa Platform kami, maupun konten yang
            terkandung di dalamnya, dapat bebas sepenuhnya dari kesalahan atau
            kelalaian.
          </li>
          <li>
            Pengguna tidak akan mengajukan tuntutan atau keberatan apapun
            terhadap keabsahan dari Syarat dan Ketentuan atau Kebijakan Privasi
            yang dibuat dalam bentuk elektronik.
          </li>
          <li>
            Pengguna tidak dapat mengalihkan hak Pengguna berdasarkan Syarat dan
            Ketentuan ini tanpa persetujuan tertulis sebelumnya dari kami.
            Namun, kami dapat mengalihkan hak kami berdasarkan Syarat dan
            Ketentuan ini setiap saat kepada pihak lain tanpa perlu mendapatkan
            persetujuan terlebih dahulu dari atau memberikan pemberitahuan
            sebelumya kepada Pengguna.
          </li>
          <li>
            Bila Pengguna tidak mematuhi atau melanggar ketentuan dalam Syarat
            dan Ketentuan ini, dan jika kami tidak mengambil tindakan secara
            langsung, bukan berarti kami mengesampingkan hak kami untuk
            mengambil tindakan yang diperlukan di kemudian hari.
          </li>
          <li>
            Syarat dan Ketentuan ini tetap berlaku bahkan setelah pemblokiran
            sementara, pemblokiran permanen, penghapusan Platform atau setelah
            berakhirnya perjanjian ini antara Anda dan kami.
          </li>
          <li>
            Jika salah satu dari ketentuan dalam Syarat dan Ketentuan ini tidak
            dapat berlaku, hal tersebut tidak akan memengaruhi ketentuan
            lainnya.
          </li>
          <li>
            Pengguna dapat menghubungi kami termasuk memiliki pertanyaan
            mengenai Syarat dan Ketentuan ini, silahkan menghubungi kami melalui{" "}
            <a href="mailto:support@colearn.id">support@colearn.id</a>
          </li>
        </ol>
      </li>
    </ol>
    <p>
      Diperbarui pada: <strong>08 Desember 2023</strong>.
    </p>
  </>
);

export default KetentuanLayananID;
